export default __webpack_public_path__ + "imgs/toKnow.6ac478b.jpeg";